import './css/components/obaia-maps-print.css';
import {Loader} from "@googlemaps/js-api-loader"

let EKODirectionsArray = []
const openInGoogleButton = document.getElementById('js-obaia-open-directions-google')
const activateDirections = document.getElementById('js-obaia-activate-directions');
const gmKeepRoute = document.getElementById('js-gm-keeproute');
const gmAddOwnLocation = document.getElementById('js-gm-addownlocation');
const gmAutocomplete = document.getElementById("js-gm-autocomplete");
const staticGoogleUrlPart = "https://www.google.com/maps/dir";

const markersOnMap = []
let EKODirectionsMeters = 0
let EKODirectionsSeconden = 0
let directionServiceActive = false
let directionsRenderer;
let infowindow;
let map;
let startMarkerAlsoFinish = false
let dynamicGoogleUrlAdresses = '';
let expeditionStarted = false;

const loader = new Loader({
    apiKey: "AIzaSyCXaXF4zKjSiV9wIT9qX3LK7ChQLkSissE",
    version: "weekly",
    language: "nl",
    libraries: ["places"]
})

loader.load().then(() => {
    map = new google.maps.Map(document.getElementById("obaia-map"), {
        center: {lat: 52.324412, lng: 5.396473},
        zoom: 10,
        mapId: 'caaf2c76d061928c',
        disableDefaultUI: true,
        fullscreenControl: true,
        zoomControl: true,
        scaleControl: true,
        streetViewControl: false
    });

    directionsRenderer = new google.maps.DirectionsRenderer({
        map: map,
        preserveViewport: true,
        suppressMarkers: true,
        suppressInfoWindows: true,
        hideRouteList: true,
        panel: document.getElementById("directionsText"),
        draggable: true,
        provideRouteAlternatives: true
    });

    setMarkers(map)
    EKOautoComplete(map)
    onloadFilters()
})

function setMarkers(map) {
    infowindow = new google.maps.InfoWindow();
    for (let i = 0; i < window.EKOMarkers.length; i++) {
        const EKOMarkerData = window.EKOMarkers[i];
        const markerIcon = {
            url: "/assets/img/base/marker-" + EKOMarkerData["type"] + ".svg",
            origin: new google.maps.Point(0, 0),
        };
        const EKOMarker = new google.maps.Marker({
            position: {lat: EKOMarkerData["lat"], lng: EKOMarkerData["lng"]},
            map: map,
            icon: markerIcon,
            title: EKOMarkerData["titel"].replace(/&amp;/g, '&'),
            type: EKOMarkerData["type"],
            subtype: EKOMarkerData["subtype"],
            license: EKOMarkerData["licentienummer"],
            id: EKOMarkerData["id"],
            lat: EKOMarkerData["lat"],
            lng: EKOMarkerData["lng"]
        });

        markersOnMap.push(EKOMarker);

        EKOMarker.addListener("click", (event) => {
            directionServiceActive = expeditionStarted === true;
            if (!directionServiceActive && activateDirections && activateDirections.__x && activateDirections.__x.$data) {
                directionServiceActive = !!activateDirections.__x.$data.expeditionStarted;
            }
            if (directionServiceActive === true) {
                const markerObject = {
                    id: EKOMarkerData.id,
                    googleMarker: EKOMarker,
                    windowMarker: EKOMarkerData,
                    latLngObject: new google.maps.LatLng(event.latLng.lat(), event.latLng.lng())
                }
                const indexFound = EKODirectionsArray.findIndex(x => x.id === EKOMarkerData.id)
                if (indexFound !== -1) {
                    if (indexFound == 0) {
                        if (EKODirectionsArray.length == 1) {
                            EKODirectionsArray[indexFound].googleMarker.setIcon("/assets/img/base/marker-" + EKODirectionsArray[indexFound].windowMarker["type"] + ".svg");
                            removeDirectionInObject(EKODirectionsArray, indexFound)
                            openInGoogleButton.classList.add('hidden')
                        } else {
                            if (confirm('Verwijderen of eindpunt maken?')) {
                                EKODirectionsArray.push(markerObject)
                                startMarkerAlsoFinish = true;
                            } else {
                                EKODirectionsArray[indexFound].googleMarker.setIcon("/assets/img/base/marker-" + EKODirectionsArray[indexFound].windowMarker["type"] + ".svg");
                                removeDirectionInObject(EKODirectionsArray, indexFound)
                            }
                        }
                    } else {
                        EKODirectionsArray[indexFound].googleMarker.setIcon("/assets/img/base/marker-" + EKODirectionsArray[indexFound].windowMarker["type"] + ".svg");
                        removeDirectionInObject(EKODirectionsArray, indexFound)
                    }

                } else {
                    EKODirectionsArray.push(markerObject)
                }

                if (EKODirectionsArray.length == 1) {
                    directionsRenderer.set('directions', null);
                    for (let i = 0; i < markersOnMap.length; i++) {
                        let marker = markersOnMap[i];
                        marker.setIcon("/assets/img/base/marker-" + marker.type + ".svg");
                    }
                    EKODirectionsArray[0].googleMarker.setIcon("/assets/img/base/marker-" + EKODirectionsArray[0].windowMarker["type"] + "-start.svg");
                    openInGoogleButton.classList.add('hidden')
                } else if (EKODirectionsArray.length > 1) {
                    EKODirectionsArray[0].googleMarker.setIcon("/assets/img/base/marker-" + EKODirectionsArray[0].windowMarker["type"] + "-start.svg");
                    if (startMarkerAlsoFinish) {
                        EKODirectionsArray[EKODirectionsArray.length - 1].googleMarker.setIcon("/assets/img/base/marker-" + EKODirectionsArray[EKODirectionsArray.length - 1].windowMarker["type"] + "-start-finish.svg");
                    } else {
                        EKODirectionsArray[EKODirectionsArray.length - 1].googleMarker.setIcon("/assets/img/base/marker-" + EKODirectionsArray[EKODirectionsArray.length - 1].windowMarker["type"] + "-finish.svg");
                    }
                    if (EKODirectionsArray.length > 2) {
                        const EKODirectionsArraySliced = EKODirectionsArray.slice(1, -1);
                        for (let i = 0; i < EKODirectionsArraySliced.length; i++) {
                            EKODirectionsArray[i + 1].googleMarker.setIcon({url: "/assets/img/base/marker-" + EKODirectionsArray[i + 1].windowMarker["type"] + "-check.svg", origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(32, 90)});
                        }
                    }

                    EKODirectionsService(map)

                    dynamicGoogleUrlAdresses = ''
                    for (let i = 0; i < EKODirectionsArray.length; i++) {
                        dynamicGoogleUrlAdresses += "/" + EKODirectionsArray[i].windowMarker["address"].replace()
                    }

                    openInGoogleButton.classList.remove('hidden')
                    openInGoogleButton.setAttribute('href', staticGoogleUrlPart + dynamicGoogleUrlAdresses)
                } else {
                    EKOMarker.setIcon(markerIcon)
                }

            } else {
                infowindow.setContent(
                    '<div class="md:p-7 bg-white inline-block min-w-[250px] md:min-w-min">' +
                    '    <h2 class="font-body font-black text-lg mb-2">' + EKOMarkerData["titel"] + '</h2>' +
                    '    <div class="text-base font-body">' +
                    EKOMarkerData["streetAddress"] + ' ' + EKOMarkerData["number"] + '<br>' +
                    EKOMarkerData["postcode"] + ' ' + EKOMarkerData["city"] + '<br>' +
                    'T ' + EKOMarkerData["telefoonnummer"] +
                    '    </div>' +
                    (EKOMarkerData["website"] ? '<a href="' + EKOMarkerData["website"] + '" class="text-base font-body font-bold text-eko-blue hover:underline block" rel="noopener noreferrer">' + EKOMarkerData["website"] + '</a>' : '') +
                    '</div>'
                );
                infowindow.open(map, EKOMarker);
            }
        });
    }
}

function EKODirectionsService(map) {
    const directionService = new google.maps.DirectionsService()
    const startingPoint = EKODirectionsArray[0].latLngObject
    const destinationPoint = EKODirectionsArray[EKODirectionsArray.length - 1].latLngObject
    const waypointsArray = []
    if (EKODirectionsArray.length > 2) {
        const EKODirectionsArraySliced = EKODirectionsArray.slice(1, -1);
        for (let i = 0; i < EKODirectionsArraySliced.length; i++) {
            waypointsArray.push({
                location: EKODirectionsArraySliced[i].latLngObject,
                stopover: true
            })
        }
    }
    directionService.route({
        origin: startingPoint,
        waypoints: waypointsArray,
        destination: destinationPoint,
        travelMode: google.maps.DirectionsTravelMode.DRIVING
    }, function (response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
            directionsRenderer.setDirections(response);
        }
    });
}

function EKOautoComplete(map) {
    const inputAutocomplete = document.getElementById("inputAutocomplete");
    const options = {
        componentRestrictions: {country: "nl"}
    };
    const autocomplete = new google.maps.places.Autocomplete(inputAutocomplete, options);
    autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }
        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(9);
        }
    })
}

let checkboxFilterLevelOne = document.getElementsByName('filterLevelOne');
let checkboxFilterLevelTwo = document.getElementsByName('filterLevelTwo');
let checkboxesCheckedFilterLevelOne = [];
let checkboxesCheckedFilterLevelTwo = [];

function onloadFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    const onLoadfilterLevelOne = urlParams.get('fl1') ? urlParams.get('fl1').split(",") : null;
    const onLoadFilterLevelTwo = urlParams.get('fl2') ? urlParams.get('fl2').split(",") : null;

    if (urlParams) {
        if (onLoadfilterLevelOne) {
            for (let i = 0; i < onLoadfilterLevelOne.length; i++) {
                document.querySelector('[data-filter-type="' + onLoadfilterLevelOne[i] + '"]').click();
            }
        }
        if (onLoadFilterLevelTwo) {
            for (let i = 0; i < onLoadFilterLevelTwo.length; i++) {
                document.querySelector('[data-filter-type="' + onLoadFilterLevelTwo[i] + '"]').click();
            }
        }
    }
}

for (let index = 0; index < checkboxFilterLevelOne.length; index++) {
    checkboxFilterLevelOne[index].onclick = function () {
        checkboxesCheckedFilterLevelOne = ([...document.querySelectorAll('input[name=filterLevelOne]:checked')]).map(function (o) {
            return o.getAttribute('data-filter-type');
        });

        let filterType = this.getAttribute('data-filter-type');
        let subfilterContainer = document.getElementById(filterType);
        if (this.checked) {
            if (subfilterContainer) {
                document.querySelectorAll('.subCategoryBox').forEach(element => element.classList.add('hidden'))
                subfilterContainer.classList.remove('hidden')
            }
        } else {
            if (subfilterContainer) {
                subfilterContainer.classList.add('hidden')
            }
        }
        filterMarkers(checkboxesCheckedFilterLevelOne, checkboxesCheckedFilterLevelTwo);
    };
}

for (let index = 0; index < checkboxFilterLevelTwo.length; index++) {
    checkboxFilterLevelTwo[index].onclick = function () {
        checkboxesCheckedFilterLevelTwo = ([...document.querySelectorAll('input[name=filterLevelTwo]:checked')]).map(function (o) {
            return o.getAttribute('data-filter-type');
        });

        let filterType = this.getAttribute('data-filter-type');
        let subfilterContainer = document.getElementById(filterType);

        if (this.checked) {

        } else {

        }
        filterMarkers(checkboxesCheckedFilterLevelOne, checkboxesCheckedFilterLevelTwo);
    };
}

const licenseSearchInput = document.getElementById('js-obaia-license-search')
licenseSearchInput.onchange = function () {
    searchLicensenumber(this.value)
}

function uncheckAllCheckboxes(array) {
    for (let index = 0; index < array.length; index++) {
        array[index].checked = false
    }
}

function searchLicensenumber(license) {
    uncheckAllCheckboxes(document.querySelectorAll('input[name=filterLevelOne]:checked'))
    uncheckAllCheckboxes(document.querySelectorAll('input[name=filterLevelTwo]:checked'))
    filterMarkers([], []);
    for (let i = 0; i < markersOnMap.length; i++) {
        let marker = markersOnMap[i];
        let visible = marker.license == license || license == ''
        marker.setVisible(visible);
    }
}

function filterMarkers(filterLevelOne, filterLevelTwo) {
    for (let i = 0; i < markersOnMap.length; i++) {
        let marker = markersOnMap[i];
        let visible = filterLevelOne.indexOf(marker.type) !== -1 || filterLevelOne.length === 0
        if (filterLevelTwo.length >= 1) {
            visible = filterLevelTwo.indexOf(marker.subtype) !== -1
        }
        marker.setVisible(visible);
    }

    let url = '/eko-zoeker/';
    if (filterLevelOne.length) {
        url += '?fl1=' + filterLevelOne.join(",");
    }
    if (filterLevelOne.length && filterLevelTwo.length) {
        url += '&fl2=' + filterLevelTwo.join(",");
    }
    window.history.replaceState("", "", url);

}

function removeDirectionInObject(array, indexFound) {
    indexFound !== -1 && array.splice(indexFound, 1)
}

const filterBar = document.getElementById('js-filter-bar');
const startExpedition = document.getElementById('js-start-expedition');
const stopExpedition = document.getElementById('js-stop-expedition');

function disableFilterbar(status) {
    filterBar.classList.remove('hidden');
}

function enableFilterbar(status) {
    filterBar.classList.add('hidden');
}

const ekozoekerInfoModalCheckbox = document.getElementById('js-dont-show-ekozoeker-info-modal-again')
let ekozoekerInfoModalShow = true;

if (localStorage.ekozoekerInfoModalShow == 'true' || !('ekozoekerInfoModalShow' in localStorage)) {
    ekozoekerInfoModalCheckbox.checked = false;
} else {
    ekozoekerInfoModalCheckbox.checked = true;
}

ekozoekerInfoModalCheckbox.addEventListener('change', (event) => {
    if (event.currentTarget.checked) {
        localStorage.ekozoekerInfoModalShow = false;
    } else {
        localStorage.ekozoekerInfoModalShow = 'true';
    }
})

startExpedition.addEventListener('click', function (event) {
    let visibleMarkersOnMap = markersOnMap.filter(markersOnMap => markersOnMap.visible == true);
    if (visibleMarkersOnMap.length <= 1) {
        alert("Je kunt geen expeditie starten met " + visibleMarkersOnMap.length + " locatie(s)");
        expeditionStarted = false;
        if (activateDirections && activateDirections.__x && activateDirections.__x.$data) {
            activateDirections.__x.$data.expeditionStarted = false;
        }
        return false;
    } else {
        disableFilterbar();

        const obaiaMapScrollpoint = document.getElementById('obaia-map').getBoundingClientRect().top + window.pageYOffset + -100;
        window.scrollTo({top: obaiaMapScrollpoint, behavior: 'smooth'});

        if (localStorage.ekozoekerInfoModalShow == 'true' || !('ekozoekerInfoModalShow' in localStorage)) {
            MicroModal.show('eko-expeditie-modal');
        }

        stopExpedition.classList.remove('hidden');
        expeditionStarted = true;
        if (activateDirections && activateDirections.__x && activateDirections.__x.$data) {
            activateDirections.__x.$data.expeditionStarted = true;
        }

        for (let i = 0; i < markersOnMap.length; i++) {
            infowindow.close(map, markersOnMap[i]);
        }
    }
});

stopExpedition.addEventListener('click', function (event) {
    enableFilterbar();
    expeditionStarted = false;
    if (activateDirections && activateDirections.__x && activateDirections.__x.$data) {
        activateDirections.__x.$data.expeditionStarted = false;
    }
    stopExpedition.classList.add('hidden');
    startExpedition.classList.remove('hidden');
    openInGoogleButton.classList.add('hidden');

    EKODirectionsArray = [];
    directionsRenderer.set('directions', null);
    for (let i = 0; i < markersOnMap.length; i++) {
        let marker = markersOnMap[i];
        marker.setIcon("/assets/img/base/marker-" + marker.type + ".svg");
    }
});

openInGoogleButton.addEventListener('click', function (event) {
    event.preventDefault();
    const options = {
        componentRestrictions: {country: "nl"}
    };
    const autocomplete = new google.maps.places.Autocomplete(gmAutocomplete, options);
    autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }
    })

    MicroModal.show('goto-google-maps-modal');
});

gmKeepRoute.addEventListener('click', function (event) {
    window.open(openInGoogleButton.href, '_blank');
});

gmAddOwnLocation.addEventListener('click', function (event) {
    if (gmAutocomplete.value.length > 0) {
        MicroModal.close('goto-google-maps-modal');
        window.open(staticGoogleUrlPart + "/" + gmAutocomplete.value + dynamicGoogleUrlAdresses, '_blank');
    } else {
        alert("Je hebt geen geldige locatie ingevoerd.");
    }
});